"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Select", {
    enumerable: true,
    get: function() {
        return Select;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var isDisplayingPlaceholder = function(placeholder, value) {
    return !value && placeholder;
};
var getDefaultTextColor = function(placeholder, value) {
    return isDisplayingPlaceholder(placeholder, value) ? "text-disabled" : "text-primary";
};
var sizes = {
    l: function(param) {
        var theme = param.theme;
        return {
            field: _object_spread({
                py: "0.75rem",
                pl: "1rem",
                pr: "3rem",
                height: "3rem"
            }, theme.textStyles["text-body-regular"]),
            icon: {
                right: "1rem"
            }
        };
    },
    m: function(param) {
        var theme = param.theme;
        return {
            field: _object_spread({
                py: "0.5rem",
                pl: "0.75rem",
                pr: "2.75rem",
                height: "2.5rem"
            }, theme.textStyles["text-body-regular"]),
            icon: {
                right: "0.75rem"
            }
        };
    },
    s: function(param) {
        var theme = param.theme;
        return {
            field: _object_spread({
                py: "0.375rem",
                pl: "0.75rem",
                pr: "2.75rem",
                height: "2rem"
            }, theme.textStyles["text-body-meta-regular"]),
            icon: {
                right: "0.75rem"
            }
        };
    }
};
var fieldDisabledStyle = function(placeholder, value) {
    return {
        backgroundColor: "background-action-disabled",
        borderWidth: "0.0625rem",
        borderColor: "ui-element-outline-disabled",
        opacity: 1,
        color: isDisplayingPlaceholder(placeholder, value) ? "text-disabled" : "text-secondary"
    };
};
var outlineFieldFocusStyle = {
    backgroundColor: "background-action-hover",
    borderColor: "ui-element-outline-default",
    boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
};
var flushedFieldFocusStyle = {
    border: "none",
    borderBottom: "0.063rem solid var(--chakra-colors-ui-element-outline-default)",
    bg: "background-action-default",
    boxShadow: "0 0.1875rem 0 0 var(--chakra-colors-primary-focus)"
};
var baseStyle = function(param) {
    var value = param.value, placeholder = param.placeholder;
    return {
        icon: {
            boxSize: "1.25rem",
            "> svg": {
                boxSize: "1.25rem !important"
            },
            color: "text-primary",
            _disabled: {
                color: "text-disabled",
                opacity: 1
            }
        },
        field: {
            backgroundColor: "background-action-default",
            border: "0.0625rem solid var(--chakra-colors-ui-element-outline-default)",
            boxShadow: "none",
            color: getDefaultTextColor(placeholder, value),
            borderRadius: "0.375rem",
            _hover: {
                backgroundColor: "background-action-hover",
                borderWidth: "0.0625rem",
                borderColor: "ui-element-outline-active"
            },
            _focus: outlineFieldFocusStyle,
            _focusVisible: outlineFieldFocusStyle,
            _disabled: _object_spread_props(_object_spread({}, fieldDisabledStyle(placeholder, value)), {
                _hover: fieldDisabledStyle(placeholder, value)
            }),
            _invalid: {
                borderColor: "transparent",
                boxShadow: "0 0 0 0.125rem var(--chakra-colors-alert-error-default)"
            }
        }
    };
};
var flushedSpacing = {
    l: {
        paddingInlineStart: "1rem",
        pr: "2.75rem",
        pt: "0.625rem"
    },
    m: {
        paddingInlineStart: "0.75rem",
        pr: "2.5rem",
        py: "0.5rem"
    },
    s: {
        paddingInlineStart: "0.75rem",
        pr: "2.5rem"
    }
};
var flushedStyle = function(param) {
    var size = param.size, value = param.value, placeholder = param.placeholder;
    return {
        field: _object_spread_props(_object_spread({
            bg: "background-action-default",
            border: "none",
            borderBottom: "0.063rem solid var(--chakra-colors-ui-element-outline-default)",
            color: getDefaultTextColor(placeholder, value)
        }, flushedSpacing[size]), {
            _hover: {
                bg: "background-action-hover",
                borderBottom: "0.063rem solid var(--chakra-colors-ui-element-outline-active)"
            },
            _focus: flushedFieldFocusStyle,
            _focusVisible: flushedFieldFocusStyle,
            _disabled: _object_spread_props(_object_spread({}, fieldDisabledStyle(placeholder, value)), {
                _hover: fieldDisabledStyle(placeholder, value)
            }),
            _invalid: {
                border: "none",
                boxShadow: "0 0.125rem 0 0 var(--chakra-colors-alert-error-default)"
            }
        })
    };
};
var Select = {
    baseStyle: baseStyle,
    sizes: sizes,
    variants: {
        outline: baseStyle,
        flushed: flushedStyle
    },
    defaultProps: {
        size: "m",
        variant: "outline"
    }
};
